<!--列表子项-->
<template>
<div class="items">
    <YorkbbsImage aspect class="cover" :src="cover" target="_blank" :href="url|hostBuild('home')"></YorkbbsImage>
    <div class="flex-cont">
        <div class="user-name"><a :href="url|hostBuild('home')" target="_blank" >{{userName}}</a></div>
        <div class="cont-text" v-if="data.contentText.length == 0"><a :href="detailUrl|hostBuild('forum')" target="_blank"> {{data.title}}</a></div>
        <div class="cont-text" v-else><a :href="detailUrl|hostBuild('forum')" target="_blank"> {{data.contentText}}</a></div>
        <div class="img-list" :class="{'single-style':data.imageList.length == 1,'double-style':(data.imageList.length % 2 == 0) && data.imageList.length <5 }">
            <template v-for="(item,index) in data.imageList">
                <div class="ig"  :key="item+'_'+index" v-if="index<9">
                    <a class="box" :href="detailUrl|hostBuild('forum')" target="_blank" ><img :src="item|webpFormat(750)" alt=""></a>
                </div>
            </template>
        </div>
        <div class="video-warp" v-if="data.imageList.length == 0 && data.videoList.length>0">
            <video controls>
                <source :src="data.videoList[0]">
            </video>
        </div>
        <div class="subject-show">
            <div class="item">
                <div class="ico"><img src="https://media7.imgyb.xyz/media/v1/image/254254e9b6d301fbe077bbf4263543c5.png" alt=""></div>
                <div class="title">寻找年味儿</div>
            </div>
        </div>
        <div class="desc">
            <div class="flex-cont">{{data.property.commentedAt|timeToStr}}回复</div>
            <div class="view-total"><i class="yk yk-home_view"></i> {{data.property.view}}</div>
            <div class="item comment"><a :href="detailUrl|hostBuild('forum')" target="_blank"><i class="yk-information"></i> {{data.property.commentTotal?data.property.commentTotal:'回复'}}</a></div>
            <div class="item admire" @click="thumbUp" :class="{clicked:data.property.hasGivenThumbUp}"><i class=" " :class="{'yk-liked':data.property.hasGivenThumbUp,'yk-like':!data.property.hasGivenThumbUp}"></i>{{data.property.thumbUpTotal?data.property.thumbUpTotal:'点赞'}}</div>
        </div>
    </div>
</div>
</template>
<script>
import { hostBuild } from '@/utils/utils'
export default {
    name:'ItemSubject',
    props: { data: Object },
    computed:{
        cover() {
            return this.data.user.avatar|| '';
        },
        url() {
            //return `//news.yorkbbs.ca/detail/${this.topic.englishName}/${this.data.id}`;
            return `/home/${this.data.user.id}`;
        },
        userName(){
            return this.data.user.username ||''
        },
        detailUrl(){
            return `/detail/${this.data.id}?topic=${this.data.property.topic[0].englishName}`
        },
        account(){
            return this.$store.getters.user;
        }
    },
    methods:{
        
        async thumbUp(){
            
            if( this.account.id == undefined){
                window.location.href = hostBuild(`/login?redirect=${window.location.href}`, 'account');
                return false;
            }
            if( this.data.property.hasGivenThumbUp == 0 ){
                let result = await this.$axios.post('/bbs/v1/give/thumb/up/to/post',{ownerId:this.data.id});
                if( result.code == 0 ){
                    this.$success('点赞成功!');
                    this.data.property.hasGivenThumbUp = 1;
                    this.data.property.thumbUpTotal +=1;
                }
                
            }else{
                let result = await this.$axios.post('/bbs/v1/drop/thumb/up/from/post',{ownerId:this.data.id});
                if( result.code == 0 ){
                    this.$success('取消点赞成功!');
                    this.data.property.hasGivenThumbUp = 0;
                    this.data.property.thumbUpTotal -=1;
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.items{
    display: flex; margin-bottom: 20px;
    *{box-sizing: border-box;}
    .cover{width:36px; height: 36px;border-radius: 50%; margin-right: 10px; border:1px solid #eee;}
    .flex-cont{flex:1}
    .user-name{
        font-size: 16px; line-height: 24px; padding: 6px 0;
        a:hover{color: #e43a3a;}
    }
}

.cont-text{font-size: 16px; line-height: 26px; color: #111; margin-bottom: 10px; max-height: 78px; overflow: hidden;}
.img-list{
    display: flex; flex-wrap: wrap;margin: 0 -5px; 
    .ig{
        width:33.33%; padding: 0 5px; margin-bottom: 10px;overflow: hidden; 
        .box{
            position: relative; width: 100%; display: block; overflow: hidden; border-radius: 4px;font-size:0;
            &:after{display: inline-block; content: ''; padding-bottom: 75%;}
            img{
               display: block; width: 100%; height: 100%; object-fit: cover; position: absolute; left: 0; top: 0;
                transition: all 300ms linear; 
            }
            &:hover{
                img{transform: scale(1.1);}
            }
        }
        /* .box{overflow: hidden;position: relative; width: 100%; height: 100%; display: block; border-radius: 4px;}
        img{
            display: block; width: 100%; height: 100%; object-fit: cover;
            transition: all 300ms linear;
        }
        &:hover{
            img{transform: scale(1.1);}
        } */
    }
    &.single-style{
        .ig{
            width:100%;max-width: 80%; height:auto; 
        }
    }
    &.double-style{
        .ig{width:50%;}
    }
}
@media screen and (max-width:768px){
    /* .items{
       padding: 20px 20px 15px 15px;border-radius: 10px;
    } */
    .img-list{
        margin: 0 -2px; padding-bottom: 6px;
        .ig{
            width:33.33%;padding: 0 2px;margin-bottom: 4px;    
        }
        &.single-style{
            .ig{
                width:100%;max-width: 100%; height:auto; max-height:141px ;
            }
        }
        
    }
    .items{
        .desc{
            .view-total,.item{margin-left: 15px;}
            .flex-cont{display: none;}
        }
    }
}
.subject-show{
    margin-bottom: 20px; display: flex;
    .item{
        display: flex; align-items: center; height: 34px; background: #fff3ea; border-radius: 17px; padding: 0 15px;
        .ico{width: 20px; height: 20px; line-height: 20px; text-align: center; color: #fff; font-size: 14px; background: linear-gradient(123deg,#ff6496 6%, #fa4a83 21%, #fa4a83 66%); border-radius: 50%; margin-right: 5px;}
        .title{font-size: 14px; line-height: 20px; font-weight: 500;}
    }
}
.desc{
    display: flex;
    .flex-cont{flex:1; font-size: 14px; line-height: 20px; color: #999;}
    .view-total{display: flex; align-items: center; margin-left: 40px; font-size: 14px; line-height: 20px; color: #111;
        i{margin-right: 5px;
            
        }
    }
    .item{
        display: flex; align-items: center; margin-left: 40px; font-size: 14px; line-height: 20px; color: #111;
        &.clicked{color: #e43a3a;}
        i{margin-right: 5px;
            
        }
        &.admire{cursor: pointer;
            i{font-size: 22px;}
        }
        &:hover{color: #e43a3a;}
        /* &.comment{
            i{transform: rotateY(180deg);}
        } */
    }
}
.video-warp{
    margin-bottom: 10px;
    video{width:100%}
}
@media screen and (min-width:768px){
.video-warp{
    background: #000;
    video{width:100%; max-height: 480px; margin: 0 auto;}
}   
}
</style>